// Fila de tickets (/v3/crm/tickets/new-tickets): marca o item aberto com aria-current="true".
// Spec docs/ticket-detail-2027/02-design/d02-v03.md §2 (+ parecer d02-v03 F-B/F-C):
//  - o clique em .tk-item-abrir só guarda o item como PENDENTE; a marca muda quando o detalhe chega,
//    visto por um MutationObserver childList (SEM subtree) em .open-ticket-detail — só o replaceContent
//    do openOppByUser troca os filhos diretos; as cargas internas (chat, linha do tempo, pedidos) são netos;
//  - se o detalhe não for trocado (erro "sem oportunidade" do B1), a marca fica no item que já estava aberto;
//  - enquanto há pendente, os outros botões da fila ficam desabilitados: o Loader cobre o mouse, não o teclado.
//    Destrava quando a requisição do item termina (o .bt-ajax tira o `disabled` do próprio botão no sucesso e
//    no erro) ou, no pior caso, em 60s (o mesmo teto do watchdog do Loader).
// Sem preventDefault/stopPropagation: o .bt-ajax do mesmo botão é delegado no document (resources/js/app.js).

const TETO_MS = 60000;
// DD-04 (docs/oportunidades-2027/02-design/dd04-mapa.md M2/M5): seletores pelo init(opts). Sem opts = os de sempre (Tickets).
const PADRAO = {
    tela: '.tk-tela', attrPainel: 'data-tk-painel', barra: '.tk-faixa[data-ticket]', item: '.tk-item', itemClasse: 'tk-item',
    proximo: '.tk-proximo', abrir: '.tk-item-abrir', filaId: 'tk-fila', lista: '#tk-fila-itens', listaId: 'tk-fila-itens',
    nome: '.tk-nome-txt', detalhe: '.open-ticket-detail', listaGuarda: '.tk-fila-lista',
};
let S = PADRAO;

const FilaSelecao = function () {

    let pendente = null;    // .tk-item clicado, aguardando o detalhe
    let travados = [];      // botões que ESTE componente desabilitou
    let teto = null;
    let vigia = null;       // observa o `disabled` do botão clicado
    let abrindo = null;     // D08 R-2: item com abertura em andamento, exposto como data-abrindo (lido pelo FilaAbas)
    // D09 F-1: "Atender o próximo" em andamento. O detalhe chega pela resposta do .tk-proximo (não por um .tk-item-abrir),
    // então não há `pendente`: o marcar() lê o ticket da faixa. Reusa o observer permanente; o estado expira em 60 s.
    let proximo = false;
    let proximoTeto = null;
    const soltarProximo = () => { proximo = false; clearTimeout(proximoTeto); proximoTeto = null; };

    const destravar = () => {
        if (abrindo) { delete abrindo.dataset.abrindo; abrindo = null; }
        travados.forEach(b => b.removeAttribute('disabled'));
        travados = [];
        clearTimeout(teto);
        teto = null;
        if (vigia) { vigia.disconnect(); vigia = null; }
    };

    // Chamado quando os filhos diretos de .open-ticket-detail mudam (o detalhe chegou).
    const marcar = () => {
        // D26 F2 (d26-v01 §5.5-3): o detalhe chegou → o painel único volta ao detalhe (sem efeito fora do painel único).
        const tela = document.querySelector(S.tela);
        if (tela) tela.removeAttribute(S.attrPainel);
        if (!pendente && proximo) {
            soltarProximo();
            const f = document.querySelector(S.barra);
            const it = f ? document.getElementById('opportunity_' + parseInt(f.dataset.ticket, 10)) : null;
            if (it && it.classList.contains(S.itemClasse)) {
                document.querySelectorAll(S.item + '[aria-current]').forEach(i => i.removeAttribute('aria-current'));
                it.setAttribute('aria-current', 'true');
            }
            return;
        }
        if (!pendente) return;
        document.querySelectorAll(S.item + '[aria-current]').forEach(i => i.removeAttribute('aria-current'));
        if (pendente.isConnected) pendente.setAttribute('aria-current', 'true');
        pendente = null;
        destravar();
    };

    const clicar = (e) => {
        const prox = e.target instanceof Element ? e.target.closest(S.proximo) : null;
        // D17b (parecer-d17b-front F1): o botão temporário do SaidaDetalhe chega aqui já desabilitado pelo .bt-ajax (jQuery roda antes).
        if (prox && (!prox.disabled || prox.classList.contains('tk-saida-tmp'))) {
            soltarProximo();
            proximo = true;
            proximoTeto = setTimeout(soltarProximo, TETO_MS);   // confirmação cancelada não fica armada para sempre
            return;
        }
        const btn = e.target instanceof Element ? e.target.closest(S.abrir) : null;
        if (!btn) return;
        soltarProximo();   // um item clicado vale mais que um "Atender o próximo" ainda armado
        const item = btn.closest(S.item);
        if (!item) return;

        destravar();            // F-C: o clique novo substitui o anterior
        pendente = item;
        abrindo = item;
        item.dataset.abrindo = '1';

        // a trava cobre também o "Atender o próximo" (D09): nada de duas aberturas ao mesmo tempo
        document.querySelectorAll(S.abrir + ', ' + S.proximo).forEach(b => {
            if (b !== btn && !b.disabled) { b.setAttribute('disabled', 'disabled'); travados.push(b); }
        });

        teto = setTimeout(() => { pendente = null; destravar(); }, TETO_MS);

        // Fim da requisição = o bt-ajax remove o `disabled` do botão. O setTimeout deixa o observer do
        // detalhe (microtarefa) rodar antes: se o detalhe não foi trocado, o pendente é descartado aqui.
        vigia = new MutationObserver(() => {
            if (btn.disabled) return;
            setTimeout(() => {
                if (pendente === item) pendente = null;
                destravar();
            }, 0);
        });
        vigia.observe(btn, { attributes: true, attributeFilter: ['disabled'] });
    };

    // D35 v18 G18-F3/F4: o botão do card ABERTO diz que o clique fecha (title + " · clique de novo para fechar"; aria-label "Fechar o ticket
    // :id de :nome"). O fechar em si mora no SaidaDetalhe. Os textos de origem ficam em data-* e voltam quando o card deixa de ser o aberto.
    // Observa aria-current (atributo) e a troca de miolo (childList): escreve só title/aria-label do botão, que nenhum dos dois filtros vê.
    let T = null;
    const txt = (k, p) => {
        if (!T) { const f = document.getElementById(S.filaId); try { T = JSON.parse((f && f.dataset.textos) || '{}') || {}; } catch (e) { T = {}; } }
        return String(T[k] || '').replace(/:([a-z]+)/g, (m, c) => (p && c in p ? String(p[c]) : m));
    };
    const rotular = () => {
        document.querySelectorAll(S.lista + ' ' + S.item).forEach(it => {
            const b = it.querySelector(':scope > ' + S.abrir);
            if (!b) return;
            const aberto = it.getAttribute('aria-current') === 'true';
            if (aberto && !('tituloAbrir' in b.dataset)) {
                b.dataset.tituloAbrir = b.getAttribute('title') || '';
                b.dataset.rotuloAbrir = b.getAttribute('aria-label') || '';
                const nomeEl = it.querySelector(S.nome);
                const id = parseInt(it.id.replace('opportunity_', ''), 10) || '';
                const extra = txt('item_fechar_title');
                if (extra) b.setAttribute('title', b.dataset.tituloAbrir + ' · ' + extra.charAt(0).toLowerCase() + extra.slice(1));
                const rot = txt('item_fechar', { id: id, nome: nomeEl ? nomeEl.textContent.trim() : '' });
                if (rot) b.setAttribute('aria-label', rot);
            } else if (!aberto && 'tituloAbrir' in b.dataset) {
                b.setAttribute('title', b.dataset.tituloAbrir);
                b.setAttribute('aria-label', b.dataset.rotuloAbrir);
                delete b.dataset.tituloAbrir;
                delete b.dataset.rotuloAbrir;
            }
        });
    };

    return {
        init: function (opts) {
            const s = Object.assign({}, PADRAO, opts || {});   // DD-04: S só muda quando a guarda liga
            const detalhe = document.querySelector(s.detalhe);
            if (!detalhe || !document.querySelector(s.listaGuarda)) return;   // só na tela de tickets nova (ou na do mapa)
            S = s;
            new MutationObserver(marcar).observe(detalhe, { childList: true });
            document.addEventListener('click', clicar);
            const itens = document.getElementById(S.listaId);
            if (itens) { new MutationObserver(rotular).observe(itens, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-current'] }); rotular(); }
        },
    };
}();

module.exports = FilaSelecao;
